import { Language } from './language';
import { LicenseStatus } from './license-status';
import { OrderItem } from './order-item';
import { OrderSpecialRequest } from './order-special-request';
import { PaymentItem } from './payment-item';
import { User } from './user';

export class ClassRegistrationDetail {
  constructor(data) {
    this.id = data.id;
    this.confirmationId = data.confirmationId;
    this.balance = data.balance;
    this.statusId = data.statusId;
    this.userId = data.userId;
    this.groupCodeId = data.groupCodeId;
    this.classTypeId = data.classTypeId;
    this.examTypeId = data.examTypeId;
    this.examLanguageId = data.examLanguageId;
    this.geographyId = data.geographyId;
    this.classId = data.classId;
    this.registerUserId = data.registerUserId;
    this.registrationGroupId = data.registrationGroupId;
    this.sourceId = data.sourceId;
    this.examScore = data.examScore;
    this.createdDate = data.createdDate;
    this.isNewSystem = data.isNewSystem;
    this.canDownloadCertificate = data.canDownloadCertificate;
    this.isCertificateExpired = data.isCertificateExpired;
    this.editDate = data.editDate;
    this.active = data.active;
    this.flag = data.flag;
    this.visible = data.visible;

    /** @type {OrderItem} */
    this.orderItem = data.orderItem;

    /** @type {OrderSpecialRequest[]} */
    this.orderSpecialRequests = data.orderSpecialRequests;

    this.class = data.class ? {
      id: data.class.id,
      name: data.class.name,
      categoryId: data.class.categoryId,
      statusId: data.class.statusId,
      classDate: data.class.classDate,
      startTime: data.class.startTime,
      endTime: data.class.endTime,
      arriveTime: data.class.arriveTime,
      examStartTime: data.class.examStartTime,
      examEndTime: data.class.examEndTime,
      examArriveTime: data.class.examArriveTime,
      classLocation: data.class.classLocation ? {
        id: data.class.classLocation.id,
        name: data.class.classLocation.name,
        displayName: data.class.classLocation.displayName,
        capacity: data.class.classLocation.capacity,
        address: {
          id: data.class.classLocation.address.id,
          street: data.class.classLocation.address.street,
          street2: data.class.classLocation.address.street2,
          city: data.class.classLocation.address.city,
          stateCode: data.class.classLocation.address.stateCode,
          zip: data.class.classLocation.address.zip,
          region: data.class.classLocation.address.region,
        },
      } : null,
      instructor: data.class.instructor ? {
        id: data.class.instructor.id,
        firstName: data.class.instructor.firstName,
        lastName: data.class.instructor.lastName,
        homeNumber: data.class.instructor.homeNumber,
        email: data.class.instructor.email,
        typeId: data.class.instructor.typeId,
        groupId: data.class.instructor.groupId,
        addressId: data.class.instructor.addressId,
        languageId: data.class.instructor.languageId,
        jobTitle: data.class.instructor.jobTitle,
        username: data.class.instructor.username,
        createdDate: data.class.instructor.createdDate,
        editDate: data.class.instructor.editDate,
        active: data.class.instructor.active,
      } : null,
    } : null;
    this.package = data.package ? {
      id: data.package.id,
      name: data.package.name,
      description: data.package.description,
      classCategoryId: data.package.classCategoryId,
      includedProducts: data.package.includedProducts ? data.package.includedProducts.map(product => ({
        id: product.id,
        name: product.name,
        code: product.code,
        unitPrice: product.unitPrice,
        typeId: product.typeId,
        editDate: product.editDate,
      })) : [],
    } : null;
    this.user = data.user ? new User(data.user) : null;
    this.studentAccessPage = data.studentAccessPage;
    this.specialRequest = data.specialRequest;
    this.certificateSendDate = data.certificateSendDate;

    /** @type {PaymentItem} */
    this.payment = data.payment;
    this.refundPayment = data.refundPayment;
    this.expirationDate = data.expirationDate;
    this.canAssignClass = data.canAssignClass;

    /** @type {Language} */
    this.language = data.language;

    /** @type {Language} */
    this.examLanguage = data.examLanguage;

    /** @type {LicenseStatus} */
    this.status = data.status;
  }
}
